export const getStartOfYear = () => new Date(new Date().getFullYear(), 0, 1);
export const getStartOfMonth = () => new Date(new Date().getFullYear(), new Date().getMonth());
